import React, {
  FC,
} from 'react';
import {
  Button, Column,
} from './Styles';
import Image from '../../../../components/Image';
import { getWindowWidth } from '../../../../lib/utils/utils';
import { HungryPanda } from '../../../../assets/base64Images/platform/platform-1';
import { UberEats } from '../../../../assets/base64Images/platform/platform-3';
import { Fantuan } from '../../../../assets/base64Images/platform/platform-2';
import { Doordash } from '../../../../assets/base64Images/platform/platform-5';
import { Menulog } from '../../../../assets/base64Images/platform/platform-4';

const PlatformLayout: FC<Props> = ({
  isEnglish,
  callback,
  style,
}) => {
  // 是不是小屏幕
  const isSmall = getWindowWidth() < 390;
  const outsideSize = isSmall ? 280 : 354;
  const platformSize = isSmall ? 80 : 104;

  const generateButton = (marginTop: number, marginLeft: number, imgPath: string, onClick: () => void) => {
    return (
      <Button
        onClick={onClick}
        style={{
          marginTop,
          marginLeft,
          width: platformSize,
          height: platformSize,
          borderRadius: '50%',
        }}
      >
        <Image
          srcImg={imgPath}
          style={{
            width: platformSize,
            height: platformSize,
          }}
        />
      </Button>
    );
  };

  return (
    <>
      {/* 商家列表 */}
      <div
        style={{
          width: outsideSize,
          height: outsideSize,
          background: '#dddddd',
          borderRadius: '50%',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: 26,
          ...style,
        }}
      >
        <Column
          style={{
            width: outsideSize,
            height: outsideSize,
            background: '#dddddd',
            borderRadius: '50%',
          }}
        >
          <div
            style={{
              width: isSmall ? 110 : 146,
              height: isSmall ? 110 : 146,
              background: '#FFFFFF',
              borderRadius: '50%',
            }}
          />
        </Column>
        {
          // 饭团商家
          generateButton(
            -outsideSize + 2,
            outsideSize / 2 - platformSize / 2,
            Fantuan,
            () => {
              callback(2);
            }
          )
        }
        {
          // 熊猫商家
          generateButton(
            -10,
            isSmall ? 10 : 3,
            HungryPanda,
            () => {
              callback(1);
            }
          )
        }
        {
          // Ubeer Eats
          generateButton(
            -platformSize,
            isSmall ? 193 : 245,
            UberEats,
            () => {
              callback(3);
            }
          )
        }
        {
          // Doordash
          generateButton(
            30,
            isSmall ? 43 : 57,
            Doordash,
            () => {
              callback(5);
            }
          )
        }
        {
          // Menulog
          generateButton(
            -platformSize,
            isSmall ? 155 : 200,
            Menulog,
            () => {
              callback(4);
            }
          )
        }
      </div>
    </>
  );
};

export interface Props {
  style?: any;
  isEnglish: boolean;
  callback: (platform: number) => void;
}

export default PlatformLayout;
